import { BaseInput, createFormField, InputProps } from '@ibsys/kit';
import { FC } from 'react';
import { cn } from '@/shared/lib';

type Props = InputProps & {
  isProcessing?: boolean;
};

const AiBaseInput: FC<Props> = (props) => {
  const { isProcessing = false, className, classNames, label, ...restProps } = props;

  return (
    <BaseInput
      {...restProps}
      label={label}
      className={cn(
        className,
        'after:bg-size-[200%_200%]! after:blur-[16px] after:opacity-0  after:inset-2  after:bottom-[-6px]  after:absolute after:transition-opacity after:duration-800 after:pointer-events-none',
        isProcessing && 'after:bg-(image:--ai-gradient-xs) after:opacity-100',
        label && 'after:top-[24px]',
      )}
      classNames={{
        ...classNames,
        input: cn(
          classNames?.input,
          'transition-all duration-600',
          'focus:border-sky-500 focus-visible:ring-0',
          isProcessing &&
            'bg-(image:--ai-gradient) bg-position-[0%_0%,_100%_0%,_0%_100%,_100%_100%] animate-inner-flow bg-size-[200%_200%]! shadow-[0_0_20px_rgba(255,220,255,0.7),inset_0_0_8px_rgba(255,255,255,0.7)] text-[#222222]',
        ),
      }}
    />
  );
};

export const AiInput = createFormField(AiBaseInput);
